import { ToastManagerReducer, } from './ToastManagerReducer';
let toasts = new Set();
const listeners = new Set();
export const toastStore = {
    subscribe(listener) {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
    getSnapshot() {
        return toasts;
    },
};
function emit() {
    for (const listener of listeners) {
        listener();
    }
}
export function dispatch(action) {
    toasts = ToastManagerReducer(toasts, action);
    emit();
}
//# sourceMappingURL=ToastManagerStore.js.map